import { createParagraph } from '@lumapps/wrex-typography/utils/createParagraph';
import { Wrex } from '@lumapps/wrex/types';

import { COLUMN } from '../constants';
import type { ColumnElement } from '../types';

/** Create a column element */
export const createColumn = (
    attributes?: Wrex.ElementAttributes<ColumnElement>,
    children: ColumnElement['children'] = [createParagraph()],
): ColumnElement => {
    return { type: COLUMN, ...attributes, children };
};
